"use client";

// React Imports
import {useEffect, useState} from "react";

export default function GlobalError({error, reset}: {error: Error & {digest?: string}; reset: () => void}) {
  const [t, setT] = useState({
    title: "Internal Server Error",
    description: "Our servers are experiencing issues. Please try again in a few moments.",
    message: "An unexpected error occurred while processing your request.",
    support: "If this problem persists, please contact support.",
    tryAgain: "Try Again",
    goHome: "Go Home",
    goBack: "Go Back",
  });

  useEffect(() => {
    // Log the error to console for debugging
    console.error("Global Error:", error);

    // Try to get language from URL
    const lang = window.location.pathname.split("/")[1] || "en";

    // Dynamically import dictionary based on language
    import(`@/data/dictionaries/${lang}.json`)
      .then((dict: any) => {
        setT({
          title: dict.common.error_500_title || "Internal Server Error",
          description: dict.common.error_500_description || "Our servers are experiencing issues. Please try again in a few moments.",
          message: dict.common.error_500_message || "An unexpected error occurred while processing your request.",
          support: dict.common.error_500_support || "If this problem persists, please contact support.",
          tryAgain: dict.common.error_try_again || "Try Again",
          goHome: dict.common.error_go_home || "Go Home",
          goBack: dict.common.error_go_back || "Go Back",
        });
      })
      .catch(() => {
        // Keep defaults if dictionary fails to load
      });
  }, [error]);

  return (
    <html>
      <body style={{margin: 0, padding: 0, overflow: "hidden"}}>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            textAlign: "center",
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            backgroundColor: "#f5f5f5",
            zIndex: 9999,
          }}>
          <div
            style={{
              maxWidth: "600px",
              backgroundColor: "white",
              padding: "48px",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}>
            <h1
              style={{
                fontSize: "72px",
                fontWeight: "bold",
                margin: "0 0 16px 0",
                color: "#dc2626",
              }}>
              500
            </h1>
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "600",
                margin: "0 0 16px 0",
                color: "#1f2937",
              }}>
              {t.title}
            </h2>
            <p
              style={{
                fontSize: "16px",
                margin: "0 0 24px 0",
                color: "#6b7280",
                lineHeight: "1.5",
              }}>
              {t.description}
            </p>

            {/* Generic error message box */}
            <div
              style={{
                marginBottom: "24px",
                padding: "12px 16px",
                backgroundColor: "#fee2e2",
                border: "1px solid #fecaca",
                borderRadius: "6px",
                fontSize: "12px",
                color: "#991b1b",
              }}>
              {t.message}
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}>
              <button
                onClick={() => reset()}
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "white",
                  backgroundColor: "#3b82f6",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
                onMouseOver={e => (e.currentTarget.style.backgroundColor = "#2563eb")}
                onMouseOut={e => (e.currentTarget.style.backgroundColor = "#3b82f6")}>
                {t.tryAgain}
              </button>
              <button
                onClick={() => (window.location.href = "/")}
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#6b7280",
                  backgroundColor: "white",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onMouseOver={e => {
                  e.currentTarget.style.backgroundColor = "#f9fafb";
                  e.currentTarget.style.borderColor = "#9ca3af";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.borderColor = "#d1d5db";
                }}>
                {t.goHome}
              </button>
              <button
                onClick={() => window.history.back()}
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#6b7280",
                  backgroundColor: "white",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onMouseOver={e => {
                  e.currentTarget.style.backgroundColor = "#f9fafb";
                  e.currentTarget.style.borderColor = "#9ca3af";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.borderColor = "#d1d5db";
                }}>
                {t.goBack}
              </button>
            </div>

            {/* Footer text */}
            <p style={{fontSize: "12px", marginTop: "24px", color: "#9ca3af"}}>{t.support}</p>
          </div>
        </div>
      </body>
    </html>
  );
}
